<template>
  <AdminPage hide-breadcrumb>
    <FlotoFixedView class="h-100 mobile-tab-panel">
      <MRow class="h-100 master-in-box" :gutter="0">
        <MCol class="h-100 flex flex-col" :sm="4" :size="12">
          <CategorySelector
            v-model="activeCategory"
            :disabled="disabled"
            @categories-loaded="categories = $event"
          />
        </MCol>
        <MCol :sm="8" :size="12" class="left-shadow-only h-100 flex flex-col">
          <div class="px-4 mb-4">
            <h5 class="text-primary">
              {{ $tc('service', 2) }}
            </h5>
            <MRow v-if="activeCategory">
              <MCol>
                <MInput
                  id="search-box"
                  v-model="searchTerm"
                  class="search-box"
                  :placeholder="$t('search')"
                  @update="searchServices"
                >
                  <template v-slot:prefix>
                    <MIcon name="search" />
                  </template>
                </MInput>
                <MDropdown
                  v-if="!disabled"
                  :options="filterOptions"
                  :value="filterType"
                  @change="handleFilterChange"
                >
                  <template v-slot:trigger>
                    <MButton id="all-btn" variant="transparent" :shadow="false">
                      {{ filterType ? $t(filterType) : $t('all') }}
                      <MIcon name="filter" size="lg" />
                    </MButton>
                  </template>
                </MDropdown>
              </MCol>
              <MCol v-if="!disabled" class="m-align-button">
                <FlotoLink
                  id="add-service-btn"
                  :to="
                    $currentModule.getRoute('create', {
                      params: { categoryId: activeCategory.id },
                    })
                  "
                  as-button
                >
                  {{ $t('add') }} {{ $tc('service') }}
                </FlotoLink>
              </MCol>
            </MRow>
          </div>
          <template v-if="activeCategory">
            <FlotoCrudContainer
              ref="servicesList"
              :key="activeCategory.id"
              :paging="false"
              :fetch-fn="getServices"
              :delete-fn="removeService"
            >
              <template v-slot:list-items="{ items, remove }">
                <!-- <MRow v-if="items.length" class="flex-1"> -->
                <MRow v-if="items.length" :gutter="0">
                  <MCol :size="12">
                    <MRow class="flex-1">
                      <MCol v-for="item in items" :key="item.id" :size="3">
                        <MRow>
                          <MCol :size="12" class="mb-8">
                            <ServiceCatalogItem
                              :service="item"
                              :search-term="searchTerm"
                              :filter-type="filterType"
                              :disabled="disabled"
                              class="h-full"
                              :is-favourite="
                                (serviceFavouriteItems || []).indexOf(
                                  item.id
                                ) >= 0
                              "
                              @clone="handleCloneService(item)"
                              @remove="remove(item)"
                              @favourite="handleFavourite(item.id)"
                            />
                          </MCol>
                        </MRow>
                      </MCol>
                    </MRow>
                  </MCol>
                </MRow>
                <!-- <MCol
                  v-for="item in items"
                  :key="item.id"
                  :sm="3"
                  :size="12"
                  class="pb-8"
                >
                  <ServiceCatalogItem
                    :service="item"
                    :disabled="disabled"
                    class="h-full"
                    @clone="handleCloneService(item)"
                    @remove="remove(item)"
                  />
                </MCol> -->
                <!-- </MRow> -->
              </template>
            </FlotoCrudContainer>
          </template>
          <div v-else class="flex-1 items-center justify-center flex italic">
            {{ __t('select_category') }}
          </div>
        </MCol>
      </MRow>
    </FlotoFixedView>
  </AdminPage>
</template>

<script>
import Pick from 'lodash/pick'
import { DraftPublishedStatusOptions } from '@utils/status'
import { authComputed } from '@state/modules/auth'
import {
  PreferenceComputed,
  PreferenceMethods,
} from '@state/modules/preference'
import {
  getServiceCatalogsApi,
  deleteServiceApi,
  cloneServiceApi,
} from '../service-catalog-api'
import CategorySelector from '../components/category-selector'
import ServiceCatalogItem from '../components/service-catalog-item'

export default {
  name: 'ServiceCatalogList',
  components: { CategorySelector, ServiceCatalogItem },
  data() {
    this.categories = []
    this.filterOptions = [{ text: this.$t('all'), key: 'all' }].concat(
      DraftPublishedStatusOptions()
    )
    return {
      activeCategory: this.$route.params.category || { id: 0 },
      searchTerm: null,
      filterType: undefined,
    }
  },
  computed: {
    ...authComputed,
    ...Pick(PreferenceComputed, ['favouriteItems']),
    disabled() {
      return this.$route.name.indexOf('request') >= 0 || this.isPortalLogin
    },
    serviceFavouriteItems() {
      return this.favouriteItems(this.$constants.SERVICE_CATALOG)
    },
  },
  created() {
    if (this.$route.params.searchTerm || this.$route.params.filterType) {
      if (this.$route.params.searchTerm) {
        this.searchTerm = this.$route.params.searchTerm
      }
      if (this.$route.params.filterType) {
        this.filterType = this.$route.params.filterType
      }
      this.$nextTick(() => {
        this.searchServices()
      })
    }
  },
  methods: {
    ...PreferenceMethods,
    setActiveCategory(category) {
      this.activeCategory = category
    },
    getServices(limit, offset) {
      return getServiceCatalogsApi(
        {
          categoryId: this.activeCategory.id,
          name: this.searchTerm,
          isPublic: this.isPortalLogin,
          ...(this.disabled
            ? { status: 'published' }
            : { status: this.filterType }),
        },
        limit,
        offset
      )
    },
    removeService(service) {
      return deleteServiceApi(service.id)
    },
    searchServices() {
      this.$refs.servicesList.refresh()
    },
    handleCloneService(service) {
      cloneServiceApi(service.id).then((data) => {
        this.$router.push(
          this.$currentModule.getRoute('edit', {
            params: { id: data.id },
          })
        )
      })
    },
    handleFilterChange(option) {
      this.filterType = option.key === 'all' ? undefined : option.key
      this.searchServices()
    },
    handleFavourite(id) {
      let favouriteItems = this.serviceFavouriteItems
      const index = favouriteItems.indexOf(id)
      if (index >= 0) {
        favouriteItems = favouriteItems.filter((i) => i !== id)
      } else {
        favouriteItems = [...favouriteItems, id]
      }
      this.updateModulePreference({
        moduleName: this.$constants.SERVICE_CATALOG,
        favouriteItems,
      }).then(() => {
        this.fetchPreferences()
      })
    },
  },
}
</script>
